import React from "react";
import Editor from "../FormControl/Editor";
import ChipMedia from "../chip/ChipMedia";
import ReadOnlyTextEditor from "../TextEditor/ReadOnlyTextEditor";

export const WEInfo = ({ row, maxHeight }) => {

  return (
    <div className="max-h-120px overflow-hidden py-2 relative" style={{ maxHeight }}>
      <ReadOnlyTextEditor content={row.comment}  />
      {row.media && row.media.length > 0 && (
        <div className={
          [
            "flex flex-wrap gap-2 items-center absolute bottom-2 inset-x-0",
            row.index % 2 === 0 ? "bg-background" : "bg-background-foreground"
          ].join(" ")
        }>
          {row.media.map((data, index) => {
            return (
              <ChipMedia
                key={`media-${index}-${data._id}-${data.type}`}
                index={index}
                data={data}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};


export const WEInfoGS = ({ row, maxHeight, buttons }) => {
  const limit = 3;
  const shortList = row?.media?.slice(0, limit);
  const restList = row?.media?.slice(limit - 1, row?.media?.length);
  const listShort =
    restList.length > 1
      ? [
          ...shortList.slice(0, limit - 1),
          {
            _id: "rest",
            name: `+${restList.length}`,
            type: 'more'
          },
        ]
      : row?.media || [];
  const hm = '25px'
  return (
    <div className=" max-h-150px overflow-hidden relative py-2 " style={{ maxHeight }}>
      <div className="overflow-hidden pb-2" style={{ maxHeight: `calc(${maxHeight} - ${hm} - 0.5rem)` }}>
        <ReadOnlyTextEditor content={row.comment}  />
      </div>
      <div className="flex justify-end absolute right-1 top-1 pl-2">
        {buttons}
      </div>
      {listShort && listShort.length > 0 && (
        <div className="flex flex-wrap gap-2 items-center px-2" style={{ height: hm }}>
          {listShort.map((data, index) => {
            return (
              <ChipMedia
                key={`media-${index}-${data._id}-${data.type}`}
                index={index}
                data={data}
                simple={true}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};
